/**
 * Admin > VM Maintenance -- status (read-only) and the guarded VM shutdown.
 * See `app.services.vm_maintenance_service` on the backend for the guards.
 */
import api from "@/services/api";
import type { VmMaintenanceStatus, VmShutdownResponse } from "@/types";

export const vmMaintenanceService = {
  getStatus: async (): Promise<VmMaintenanceStatus> => {
    const { data } = await api.get<VmMaintenanceStatus>("/admin/vm-maintenance/status");
    return data;
  },
  shutdown: async (confirmation: string): Promise<VmShutdownResponse> => {
    const { data } = await api.post<VmShutdownResponse>("/admin/vm-maintenance/shutdown", { confirmation });
    return data;
  },
};

export default vmMaintenanceService;
